import { unref, ref, shallowRef } from 'vue';
import '../constants/index.mjs';
import { DefaultPageInfo } from '../constants/page.mjs';

function useTable(_pageInfo) {
  const defaultPageInfo = unref(_pageInfo) || DefaultPageInfo;
  const tableData = ref([]);
  const pageInfo = ref({ ...defaultPageInfo });
  const total = ref(0);
  const loadingStatus = ref(false);
  const buttons = shallowRef([]);
  return {
    tableData,
    pageInfo,
    total,
    loadingStatus,
    buttons
  };
}

export { useTable };
